import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { BoxSpg, DividerSpg, ApplicationSubtype, RecognitionKind } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { useTranslation } from "react-i18next";
import React from "react";
import { createSEEducationValidationSchema } from "../../../../../../yup/secondaryEducation/seEducationValidationSchemas";
import {
  completeEducationStep,
  setStepEducationEdited,
} from "../../../../../../store/redux/slice/Forms/seVerLetterForm";
import { initialSeVerLetterEducation } from "../../../../../../init/seVerLetterInitialValues";
import SecondarySchoolFormSection from "./SecondarySchoolFormSection";
import DiplomaDataFormSection from "./DiplomaDataFormSection";
import RecognitionPurposeFormSection from "./RecognitionPurposeFormSection";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import AdditionalInfoFormSection from "./AdditionalInfoFormSection";
import PreviousCertificateFormSection from "./PreviousCertificateFormSection";

const SeVerLetterStepEducation = () => {
  const { t } = useTranslation();

  const seVerLetterForm = useAppSelector((state) => {
    return state.Forms.SEVerLetterForm;
  });

  const fullSchema = createSEEducationValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    seVerLetterForm.educationDetails,
    seVerLetterForm.id,
    baseEndpointPaths.seRecognition,
    formalSchema,
    setStepEducationEdited,
    completeEducationStep,
    initialSeVerLetterEducation,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seVerLetterForm.educationDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
          })}
        >
          <PreviousCertificateFormSection infoText={"l.ver.letter.previous.certificate.info.text"} />
          <RecognitionPurposeFormSection recognitionKind={RecognitionKind.VERIFICATION_LETTER} />
          <SecondarySchoolFormSection foreignGradingScaleCountry={false} />
          <DiplomaDataFormSection profQualifSection={true} gradingScaleSection={false} label={"t.school.diploma.se"} />
          <AdditionalInfoFormSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default SeVerLetterStepEducation;
